import { DataTableNew } from '@seapoint/client/src/design-system/data-table-new';
import { BeneficiaryType } from '@seapoint/server/enums';
import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { FormState } from 'react-hook-form';
import { PayrollFormData } from './financial-information-form';
import {
  financialInformationTableColumnDefinition,
  PayrollEmployee,
} from './financial-information-table-column-definition';

export const FinancialInformationTable = ({
  employees,
  onReferenceChange,
  onNetPayChange,
  formState,
}: {
  employees: PayrollEmployee[];
  onReferenceChange?: (employeeId: string, reference: string) => void;
  onNetPayChange?: (employeeId: string, netPay: string) => void;
  currencySymbol?: string;
  formState: FormState<PayrollFormData>;
}) => {
  const hasScanEmployee = employees.some((employee) => employee.destination?.type === BeneficiaryType.SCAN);

  const table = useReactTable({
    data: employees,
    columns: financialInformationTableColumnDefinition,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    meta: {
      rowHeight: 76,
      showAccountOptions: hasScanEmployee,
      onReferenceChange,
      onNetPayChange,
      formState,
    },
  });

  return <DataTableNew.Table table={table} aria-label="Financial information table" className="w-full min-w-0" />;
};
